// blockUI overrides
$.blockUI.defaults.message = '<span class="text-semibold"><i class="fa fa-spinner spinner position-left"></i>&nbsp; Please Wait...</span>';
$.blockUI.defaults.overlayCSS = {
    backgroundColor: '#fff',
    opacity: 0.8,
    cursor: 'wait'
};
$.blockUI.defaults.css = {
    border: 0,
    padding: '10px 15px',
    color: '#fff',
    width: 'auto',
    '-webkit-border-radius': 2,
    '-moz-border-radius': 2,
    'border-radius': 2,
    backgroundColor: '#7cb342'
}
$.blockUI.PAGE = {
    css: {
        top: '50%',
        left: '50%',
        margin: '-20px 0 0 -67.5px'
    }
}
const EntityType = {
    Property: 4,
    WorkOrder: 5
}
const SearchType = {
    Property: 'Property',
    WorkOrder: 'WorkOrder',
    Accounting: 'Accounting'
}
const PropertyStatus = {
    Active: 3,
    PendingSubmission: 4
}

function initialize() {
    if ($.fn.footable) {
        $('.js-footable').footable();
    }
}

function danger(title, message, size = null) {
    bootbox.alert({
        className: 'bootbox-danger',
        size,
        title,
        message,
        buttons: {
            ok: {
                className: 'bg-danger-800'
            }
        }
    });
}

$(() => {
    $.ajaxSetup({ cache: false });
    if (localStorage) {
        $('[data-collapse-name]').each(function () {
            const $this = $(this),
                value = localStorage.getItem($this.data('collapse-name'));
            if (value === 'true') {
                $this.addClass('rotate-180');
                $this.closest('.panel-heading').siblings('.panel-collapse').removeClass('in');
            }
        });
    }

    $(document).on('click', '.ie button[type=submit][form]:not(.js-bootbox-confirm, .js-bootbox-alert, .js-bootbox-prompt, .js-bootbox-custom)', function () {
        const formId = $(this).attr('form');
        $(`#${formId}`).submit();
    }).on('click', '.ie button[type=reset][form]:not(.js-bootbox-confirm, .js-bootbox-alert, .js-bootbox-prompt, .js-bootbox-custom)', function () {
        const formId = $(this).attr('form');
        $(`#${formId}`)[0].reset();
    });

    initialize();

    $(document).on('hidden.bs.modal', '.modal', function () {
        if ($('.modal.in').length > 0) {
            $('body').addClass('modal-open');
        }
    });

    const $search = $('.navbar-form input[type=search]');
    if ($search.length) {
        const bloodhound = new Bloodhound({
            datumTokenizer(datum) {
                return Bloodhound.tokenizers.whitespace(datum.assetId);
            },
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: $search.data('url'),
                replace() {
                    return `${$search.data('url')}?searchType=${encodeURIComponent($search.closest('form').find('input[type=hidden]').val())}&keyword=${encodeURIComponent($search.val())}`;
                }
            },
            limit: 10
        });
        bloodhound.initialize();

        $search.typeahead({
            highlight: true,
            minLength: 1,
            hint: false,
            classNames: {
                highlight: 'alpha-orange'
            }
        }, {
            displayKey: 'id',
            source: bloodhound.ttAdapter(),
            limit: 10,
            templates: {
                notFound: '<div class="dropdown-header highlight text-center">No Results Found</div>',
                suggestion(entity) {
                    var selectedsearchType = $search.closest('form').find('input[type=hidden]').val();
                    return `<div>
                    <div class="text-size-large text-semibold">${entity.entityTypeId === EntityType.Property ? 'Property' : 'Work Order'} #${entity.entityId}</div>
                    <p class="text-size-small">${entity.status}</p>
                    ${selectedsearchType === SearchType.Accounting ? `<p class="text-size-small"> Accounting #${entity.referenceNumber} </p>` : ''} 
                    <div class="text-size-mini text-muted">${entity.address1}<br/>${entity.city}, ${entity.state} ${entity.zipCode}</div>
                </div>`;
                }
            }
        }).on('typeahead:select', function (e, obj) {
            window.location.href = obj.protectedUrl;
        });

        $(document).on('click', '.navbar-form a[data-search-type-id]', function (e) {
            e.preventDefault();

            const $this = $(this),
                $form = $this.closest('form'),
                searchTypeId = $this.data('search-type-id');

            $form.find('input[type=hidden]').val(searchTypeId);

            if (searchTypeId === SearchType.Accounting) {
                $form.find('a.dropdown-toggle .fa').removeClass('fa-wrench fa-home').addClass('fa-list');
            }
            else if (searchTypeId === SearchType.Property) {
                $form.find('a.dropdown-toggle .fa').removeClass('fa-wrench fa-list').addClass('fa-home');
            } else {
                $form.find('a.dropdown-toggle .fa').removeClass('fa-home fa-list').addClass('fa-wrench');
            }

            $search.typeahead('destroy');
            $search.typeahead({
                highlight: true,
                minLength: 1,
                hint: false,
                classNames: {
                    highlight: 'alpha-orange'
                }
            }, {
                displayKey: 'id',
                source: bloodhound.ttAdapter(),
                limit: 10,
                templates: {
                    notFound: '<div class="dropdown-header highlight text-center">No Results Found</div>',
                    suggestion(entity) {
                        var selectedsearchType = $search.closest('form').find('input[type=hidden]').val();
                        return `<div>
                <div class="text-size-large text-semibold">${entity.entityTypeId === EntityType.Property ? 'Property' : 'Work Order'} #${entity.entityId}</div>
                <p class="text-size-small">${entity.status}</p>
                ${selectedsearchType === SearchType.Accounting ? `<p class="text-size-small"> Accounting #${entity.referenceNumber} </p>` : ''} 
                <div class="text-size-mini text-muted">${entity.address1}<br/>${entity.city}, ${entity.state} ${entity.zipCode}</div>
            </div>`;
                    }
                }
            }).on('typeahead:select', function (e, obj) {
                window.location.href = obj.protectedUrl;
            });
        });

        $(document).on("change", ".js-checkbox[data-toggle='select']", function () {
            var elem = $(this);
            var target = $(elem.attr('data-target'));

            if (elem.is(":checked")) {
                target.collapse("show");

            } else {
                target.collapse("hide");
            }
        });
        $(document).on("change", "select[data-toggle='select']", function () {
            var elem = $(this);
            var target = $(elem.attr('data-target'));
            var show = elem.attr('data-show-values');
            if (show !== undefined) {
                var showValues = show.split(",");
                if (showValues.indexOf(elem.val()) >= 0) {
                    target.collapse("show");
                } else {
                    target.collapse("hide");
                }
            } else {
                if (elem.val() === "true" || elem.val() > 0) {
                    target.collapse("show");

                } else {
                    target.collapse("hide");
                }
            }
        });
    }


    $(document).ajaxStop(() => {
        initialize();
    }).ajaxError((event, jqXhr, ajaxSettings, thrownError) => {
        if (jqXhr.status === 0 || jqXhr.readyState === 0) {
            return; // these are not true errors
        }

        if (jqXhr && jqXhr.responseJSON) {
            console.error(jqXhr.responseJSON);

            if (jqXhr.responseJSON.error) {
                let error = jqXhr.responseJSON.error;
                let stackTrace = '';

                if (error.stackTrace) {
                    stackTrace = `<pre class="mt-20"><code>${error.stackTrace}</code></pre>`;
                }

                danger('Error Recieved', `${error.message}${stackTrace}`, stackTrace ? 'large' : null);
                //bootbox.alert({
                //    className: 'bootbox-danger',
                //    size: stackTrace ? 'large' : null,
                //    title: 'Error Received',
                //    message: `${error.message}${stackTrace}`,
                //    buttons: {
                //        ok: {
                //            className: 'bg-danger-800'
                //        }
                //    }
                //});
            } else if (jqXhr.responseJSON.message) {
                let message = jqXhr.responseJSON.message;

                bootbox.alert({
                    className: `bootbox-${message.type.toLowerCase()}`,
                    title: message.title,
                    message: message.message,
                    buttons: {
                        ok: {
                            className: `bg-${message.type.toLowerCase()}-800`
                        }
                    }
                });
            } else if (jqXhr.responseJSON.validation) {
                let validation = jqXhr.responseJSON.validation;

                bootbox.alert({
                    className: `bootbox-warning`,
                    title: 'Invalid Data Received',
                    message: `<ul><li>${validation.messages.join('</li><li>')}</li></ul>`,
                    buttons: {
                        ok: {
                            className: `bg-warning-800`
                        }
                    }
                });
            } else if (jqXhr.responseJSON.security) {
                let security = jqXhr.responseJSON.security;
                let stackTrace = '';

                if (security.stackTrace) {
                    stackTrace = `<pre class="mt-20"><code>${security.stackTrace}</code></pre>`;
                }
                bootbox.alert({
                    className: `bootbox-info`,
                    size: stackTrace ? 'large' : null,
                    title: 'Forbidden',
                    message: `${security.message}${stackTrace}`,
                    buttons: {
                        ok: {
                            className: `bg-info-800`
                        }
                    }
                });
            }
        } else {
            console.log(event, jqXhr, ajaxSettings, thrownError);
            if (thrownError !== 'canceled') {
                bootbox.alert({
                    className: 'bootbox-danger',
                    title: 'Error Received',
                    message: 'An error occured while processing the request.',
                    buttons: {
                        ok: {
                            className: 'bg-danger-800'
                        }
                    }
                });
            }
        }
    });

    //collapse or expand the header panel based on storage value
    //$(function () {
    //    for (var i = 0; i < localStorage.length; i++) {
    //        var collapseObject = JSON.parse(localStorage.getItem(localStorage.key(i)));
    //        const $this = $('.panel [data-collapse-name= "' + collapseObject.name + '"]');
    //        if (collapseObject.value === true) {
    //            $this.addClass('rotate-180');
    //            $this.parents('.panel').addClass('panel-collapsed');
    //            $('.panel-collapsed').children('.panel-heading').nextAll().hide(200);
    //        }
    //    }
    //});
});